import { render, staticRenderFns } from "./CharacterEmotion.vue?vue&type=template&id=2ed6de6f&scoped=true"
import script from "./CharacterEmotion.vue?vue&type=script&lang=js"
export * from "./CharacterEmotion.vue?vue&type=script&lang=js"
import style0 from "./CharacterEmotion.vue?vue&type=style&index=0&id=2ed6de6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6de6f",
  null
  
)

export default component.exports